import React, { useState, useEffect } from 'react';
import axios from 'axios';
import JobsLanding from '../pages/JobsLanding';  // Coming Soon page
import JobsMarketing from '../pages/JobsMarketing';  // Marketing page

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const JobsRouter = () => {
  const [jobsEnabled, setJobsEnabled] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkJobsStatus();
  }, []);

  const checkJobsStatus = async () => {
    try {
      const response = await axios.get(`${API}/feature-flags/jobs-enabled`);
      setJobsEnabled(response.data.enabled);
    } catch (error) {
      console.error('Failed to check jobs status:', error);
      setJobsEnabled(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If JOBS_ENABLED is OFF → Show Coming Soon page
  // If JOBS_ENABLED is ON → Show Marketing page
  return jobsEnabled ? <JobsMarketing /> : <JobsLanding />;
};

export default JobsRouter;
